import * as React from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'react-materialize';

// styling
import './RecallInteractionTemplate.css';

// components
import NavBar from '../../components/CustomNav/CustomNav.Component';
import RecallInteraction from '../../components/RecallInteraction/RecallInteraction.Component';


class RecallInteractionTemplatePage extends React.Component {
    public render() {
      const dashboardStyles = {
        dashBody: {
          height: 'auto',
          marginTop: '1%',
          width: 1080,
        },

        wrapper: {
          display: 'flex',
          justifyContent: 'center'
        }
      }
      return (
        <div>
        <NavBar />
        <div style={dashboardStyles.wrapper}>
          <div style={dashboardStyles.dashBody}>
            <Link to="/dashboard"><h6>Back</h6></Link>
            <h5>Recall Interaction Template Preview</h5>
            {/*<RecallInteraction demomode={true} show={false} submittext="Submit" lessonid="1" interactionid="1" completiontext="Congrats on completing!" penalty={2} timelimit={120} introtext="This is the default introductory text to be displayed later" question="dyuru" redwords="yrururu"/>
            */}
          <Button waves='light'>Use template</Button>
          <p/>
          <Button waves='light'>Template Settings</Button>

          </div>
          </div>
        </div>
      );
    }
}

export default RecallInteractionTemplatePage;



// WEBPACK FOOTER //
// ./src/pages/RecallInteractionTemplate/RecallInteractionTemplatePage.Component.tsx